import { Field, FieldArray, useFormikContext } from "formik";
import React, { Suspense } from "react";
import style from "./Paragraph.module.scss";
import { ReactQuillWrapper } from "../../../Offers/components/ReactQuillWrapper";
import { Button, Group, Stack, TextInput, Title } from "@mantine/core";
import type { FieldProps } from "formik";

type Props = {
  index: number;
  onRemove(): void;
};

const Paragraph: React.FC<Props> = ({ index, onRemove }) => {
  const { setFieldValue, values } = useFormikContext();
  const paragraphs = (values as {
    paragraphs: { text: string; title?: string; quotes: { text: string }[] }[];
  }).paragraphs;
  const paragraph = paragraphs[index];
  const quotes = paragraph?.quotes ?? [];

  return (
    <Stack gap="md" className={style.container}>
      <Title order={4}>Paragraf</Title>
      <Field name={`paragraphs.${index}.title`}>
        {({ field, meta }: FieldProps) => (
          <TextInput
            label="Tytuł"
            {...field}
            value={field.value ?? ""}
            error={meta.touched ? meta.error : undefined}
          />
        )}
      </Field>
      <div className={style.text}>
        <div>Tekst</div>
        <Suspense fallback={<div>Ładowanie</div>}>
          <ReactQuillWrapper
            value={paragraph?.text ?? ""}
            onChange={(value) => {
              setFieldValue(`paragraphs.${index}.text`, value);
            }}
          />
        </Suspense>
      </div>

      <FieldArray name={`paragraphs.${index}.quotes`}>
        {({ remove, push }) => {
          return (
            <>
              {quotes.map((_q: { text: string }, i: number) => (
                  <Stack
                    key={`quote-${index}-${i}`}
                    gap="sm"
                    align="stretch"
                  >
                    <Field name={`paragraphs.${index}.quotes.${i}.text`}>
                      {({ field, meta }: FieldProps) => (
                        <TextInput
                          label="Cytat"
                          {...field}
                          value={field.value ?? ""}
                          error={meta.touched ? meta.error : undefined}
                        />
                      )}
                    </Field>
                    <Button
                      type="button"
                      variant="subtle"
                      color="red"
                      size="compact-sm"
                      radius="md"
                      w="fit-content"
                      onClick={() => remove(i)}
                    >
                      Usuń cytat
                    </Button>
                  </Stack>
              ))}
              <Button
                type="button"
                variant="light"
                color="orange"
                size="sm"
                radius="md"
                onClick={() => {
                  push({
                    text: "",
                  });
                }}
              >
                Dodaj cytat
              </Button>
            </>
          );
        }}
      </FieldArray>

      <Group justify="flex-end" mt="xs">
        <Button
          type="button"
          variant="light"
          color="red"
          size="sm"
          radius="md"
          onClick={onRemove}
        >
          Usuń paragraf
        </Button>
      </Group>
    </Stack>
  );
};

export default Paragraph;
